<template>
    <div>
        <Breadcrumb pageTitle="DAVCA Consultant IT" pageTitles="Consultant IT"/>
        <Erp/>
    </div>
</template>

<script>
    import Erp from '@/components/ERP/Erp'
    import Breadcrumb from '@/components/Common/Breadcrumb'
    export default {
        name: 'ERPView',
        components: {
            Erp,
            Breadcrumb
        }
    }
</script>